/**
 * 考试
 */
import examApi from '../../api/exam.api'
import _ from 'lodash'

const state = {
    classifyList: [],
    examList: [],
    totalTime: 0,
    timeParams: {}
};

const getters = {
    // 获取随机考试题目
    getRandomExam: (state) => () => {
        let lowArray = [], highArray = [];
        _.forEach(state.examList, item => {
            if (item.difficulty <= 3) {
                lowArray.push(item);
            } else {
                highArray.push(item);
            }
        });
        lowArray = _.shuffle(lowArray);
        highArray = _.shuffle(highArray);
        for (let i = 0; i < highArray.length; i ++) {
            let index = (i + 1) * 5;
            if (index >= lowArray.length) {
                lowArray.push(highArray[i])
            } else {
                lowArray.splice(index, 0, highArray[i]);
            }
        }
        return lowArray;
    },
    // 获取对应分类的题目
    getRandomKeyExam: (state) => (key) => {
        let classify = _.find(state.classifyList, {key}) || {};
        let array = _.shuffle(_.filter(state.examList, {classifyId: classify._id}));
        return array.slice(0, 20);
    },
    // 获取当前考试分类
    getCurrentClassify: state => key => {
        return _.find(state.classifyList, {key}) || {};
    },
    // 根据准确率得到评级
    getLevel: () => accuracy => {
        let list = [
            {index: 1, level: 'S', text: '优秀'},
            {index: 2, level: 'A', text: '良好'},
            {index: 3, level: 'B', text: '中等'},
            {index: 4, level: 'C', text: '及格'},
            {index: 5, level: 'D', text: '不及格'}
        ];
        let level;
        accuracy = accuracy || 0;
        if (accuracy >= 95) {
            level = 1;
        } else if (accuracy >= 80 && accuracy < 95) {
            level = 2;
        } else if (accuracy >= 70 && accuracy < 80) {
            level = 3;
        } else if (accuracy >= 60 && accuracy < 70) {
            level = 4;
        } else {
            level = 5;
        }
        return list[level-1] || {};
    }
};

const mutations = {
    setClassify(state, res) {
        state.classifyList = res;
    },
    setExam(state, res) {
        state.timeParams = _.pick(res, ['totalTime', 'viewTime']);
        state.examList = res.list;
    },
    setTime(state, key) {
        let time = key ? state.timeParams.viewTime : state.timeParams.totalTime;
        state.totalTime = time || 60;
    }
};

const actions = {
    // 获取分类列表
    getClassify({state, commit}) {
        return state.classifyList.length ? state.classifyList : examApi.getClassify().then(res => {
            commit('setClassify', res);
            return res;
        })
    },
    // 获取题目列表
    async getExamList({state, getters, dispatch, commit}, key) {
        await dispatch('getClassify');
        if (!state.examList.length) {
            let res = await examApi.getList();
            commit('setExam', res);
        }
        commit('setTime', key);
        return key ? getters.getRandomKeyExam(key) : getters.getRandomExam();
    },
    getFirstRank() {
        return examApi.getFirstRank();
    },
    submitExam({}, data) {
        return examApi.submitExam(data);
    },
    cancelExam({}, data) {
        return examApi.cancelExam(data);
    },
    getNewestItem() {
        return examApi.getNewestItem();
    },
    getRankingList() {
        return examApi.getRankingList();
    },
    // 排行榜点赞
    like({}, id) {
        return examApi.like(id);
    },
    // 获取成员平均能力统计数据
    getMeanPower() {
        return examApi.getMeanPower();
    },
    // 获取个人面试官战绩统计数据
    getExamLevel() {
        return examApi.getExamLevel();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./app/store/modules/exam.js